import { IconAiEndpoint } from './icon-ai-endpoint';
import { IconAsset } from './icon-asset';
import { IconCode } from './icon-code';
import { IconEndpoint } from './icon-endpoint';
import { IconEntryPoint } from './icon-entry-point';
import { IconFinding } from './icon-finding';
import { IconSignal } from './icon-signal';
import { IconWebPage } from './icon-web-page';
import type { EntityIconAppearance, EntityIconDensity } from './entity-icon-base';

export type EntityIconType =
  | 'signal'
  | 'finding'
  | 'endpoint'
  | 'aiEndpoint'
  | 'webPage'
  | 'asset'
  | 'code'
  | 'entryPoint';

export type EntityIconProps = {
  type: EntityIconType;
  appearance?: EntityIconAppearance;
  density?: EntityIconDensity;
};

const ICON_MAP = {
  signal: IconSignal,
  finding: IconFinding,
  endpoint: IconEndpoint,
  aiEndpoint: IconAiEndpoint,
  webPage: IconWebPage,
  asset: IconAsset,
  code: IconCode,
  entryPoint: IconEntryPoint,
} as const;

export function EntityIcon({ type, appearance, density }: EntityIconProps) {
  const Icon = ICON_MAP[type];
  return <Icon appearance={appearance} density={density} />;
}

export type { EntityIconAppearance, EntityIconDensity };
